import {DataSourceMapping} from "../Catalog/DataSourceMapping";
import {MappingOrigin} from "./mappingOrigin";

export class ManufacturerMapping {
  constructor(
    public id: string,
    public containerId: string,
    public catalogId: string,
    public dataSourceMapping: DataSourceMapping,
    public origin?: MappingOrigin,
  ) {}
}
